var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./banner-slider.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-45396f60\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./banner-slider.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home-geolocal/components/banner-slider/banner-slider.vue
// module id = 257
// module chunks = 0